import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { changeLanguage, supportedLngs } from '@shared/config';
import { ChevronDownIcon } from 'lucide-react';
import { useState } from 'react';

export type LanguageSelectProps = {
  onChange?: (value: string) => void;
  value?: string;
};

export const LanguageSelect = ({
  onChange,
  value: externalValue,
}: LanguageSelectProps) => {
  const sessionLng = localStorage.getItem('i18nextLng');
  const [value, setValue] = useState(externalValue || sessionLng);

  const handleChange = (lng: string) => {
    changeLanguage(lng);
    onChange?.(lng);
    setValue(lng);
  };

  const selectedLng = supportedLngs.find(lng =>
    externalValue ? lng.value === externalValue : lng.value === value,
  );

  return (
    <Menu>
      <MenuButton
        as={Button}
        size="sm"
        variant="outline"
        rightIcon={<ChevronDownIcon />}
      >
        {selectedLng?.label}
      </MenuButton>
      <MenuList>
        {supportedLngs.map(lng => (
          <MenuItem
            key={lng.value}
            value={lng.value}
            onClick={() => handleChange(lng.value)}
          >
            {lng.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
